import React from "react";

import useTranslations from "../../../hooks/useTranslations";

import { Textarea } from "../../wombat-ui";
import { FormStepProps } from "../../../screens/ReviewFormScreen";
import { ReviewFullFragment } from '../../../graphql/generated/definitions';

const ReviewInformationForm: React.FC<
  Omit<FormStepProps, "onNext" | "unregister" | "setValue" | "control"> & {
    defaultValues?: ReviewFullFragment;
  }
> = ({ register, defaultValues }) => {
  const t = useTranslations();

  return (
    <div className="w-1/2">
      <Textarea
        id="reviewDescriptionInputs"
        name="description"
        ref={register()}
        label={t("reviews.reviewDescriptionLabel") as string}
        defaultValue={defaultValues?.description ?? ""}
      />
    </div>
  );
};

export default React.memo(ReviewInformationForm);
